import { getTickmillCompanyNameByType } from '@/api/Clients/Types/TickmillCompanyTypes'
import { NameDto } from '@/api/Common/Types'
import { Badge, CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { SwapFreeOptionDto } from 'api/Clients/Types/SwapFreeOptionDto'
import { SwapFreeOptionKey } from 'api/Clients/Types/SwapFreeRatingKey'
import classNames from 'classnames'

import styles from './SwapFreeRatingPage.module.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const swapFreeRatingColumns: GridColumn[] = [
  {
    title: 'Country',
    field: SwapFreeOptionKey.country,
    width: 150,
    minResizableWidth: 100,
    show: true,
    filterable: false,
    sortable: false,
  },
  {
    title: 'Operating Company',
    width: 150,
    cell: (props: GridCellProps): JSX.Element => {
      const tickmillCompanies = props.dataItem?.tickmillCompanies || []
      if (tickmillCompanies.length <= 0) {
        return <td />
      }

      return (
        <td className={classNames(styles.column)}>
          {tickmillCompanies.map((x: NameDto) => (
            <>
              <CompanyTag id={x.id}>{getTickmillCompanyNameByType(x.id)}</CompanyTag>{' '}
            </>
          ))}
        </td>
      )
    },
    show: true,
  },
  {
    title: 'Green',
    field: SwapFreeOptionKey.green,
    width: 100,
    minResizableWidth: 100,
    show: true,
    filterable: false,
    sortable: false,
  },
  {
    title: 'Red',
    field: SwapFreeOptionKey.red,
    width: 100,
    minResizableWidth: 100,
    show: true,
    filterable: false,
    sortable: false,
  },
  {
    title: 'Days till Suspended',
    field: SwapFreeOptionKey.daysTillSuspended,
    width: 150,
    minResizableWidth: 100,
    show: true,
    filterable: false,
    sortable: false,
  },
  {
    title: 'Enabled',
    field: SwapFreeOptionKey.enabled,
    cell: ({ dataItem }) => {
      const rowData = dataItem as SwapFreeOptionDto
      const isEnabled = rowData.enabled

      return (
        <td>
          <div className={styles.option}>
            <Badge variant={isEnabled ? 'green' : 'red'} className='mr-2'>
              {isEnabled ? 'Enabled' : 'Disabled'}
            </Badge>
          </div>
        </td>
      )
    },
    width: 100,
    minResizableWidth: 100,
    show: true,
    filterable: false,
    sortable: false,
  },
]
